import { hideComponent } from 'BreetHelpers';
import { useWindowSize } from 'BreetHooks';

export const useComponentVisibilityApi = (size?: number) => {
	const windowSize = useWindowSize();
	const customSize = size ?? 768;

	const isMobile = windowSize.isClient && windowSize.width <= customSize;

	const hideComponentOnDesktop = hideComponent(windowSize, 'desktop', customSize);
	const hideComponentOnMobile = hideComponent(windowSize, 'mobile', customSize);

	return {
		hideComponentOnDesktop,
		hideComponentOnMobile,
		isMobile,
	};
};
